import { isMobile } from "@growtherapy/analytics";
import { twMerge } from "tailwind-merge";
import {
  LocalScreenShareComponentProps,
  RemoteScreenShareComponentProps,
} from "../../core/types";

export function ZoomLocalScreenShare({
  videoRef,
}: LocalScreenShareComponentProps) {
  const isMobileDevice = isMobile(navigator.userAgent);

  return (
    <div className="w-full h-full flex items-center justify-center">
      <video // eslint-disable-line  jsx-a11y/media-has-caption
        className={twMerge(
          "relative max-w-full sm:w-unset fs-exclude display-block max-h-full",
          isMobileDevice && "sm:w-full",
        )}
        data-testid="screenshare-video"
        ref={videoRef}
      />
    </div>
  );
}

/**
 * Screen share must use a different parent video-player-container
 */
export function ZoomRemoteScreenShare({
  videoRef,
}: RemoteScreenShareComponentProps) {
  return (
    <video-player-container class="w-[min(100vw,1280px)]">
      <video-player
        data-testid="screenshare-video"
        style={{ width: "100%" }}
        ref={videoRef}
      />
    </video-player-container>
  );
}
